// Human-readable size from bytes, base 1024: "512 B", "1.5 KB", "69.6 GB"
const UNITS = ['B', 'KB', 'MB', 'GB', 'TB', 'PB']

export default function formatBytes (bytes) {
  if (typeof bytes !== 'number' || !isFinite(bytes) || bytes < 0) return '—'
  if (bytes < 1024) return `${Math.round(bytes)} B`
  const exponent = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), UNITS.length - 1)
  return `${(bytes / Math.pow(1024, exponent)).toFixed(1)} ${UNITS[exponent]}`
}
